<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Examples" />
    <vc-footer>left-aligned footer (default)</vc-footer>
    <p>&nbsp;</p>
    <vc-footer color="pink" align="center">center-aligned footer</vc-footer>
    <p>&nbsp;</p>
    <vc-footer color="green" align="right">right-aligned footer</vc-footer>
    <p>&nbsp;</p>
    <vc-footer color="deep-purple l-100" align="center" :dark="false">light theme</vc-footer>
    <p>&nbsp;</p>
    <vc-footer color="orange" narrow>narrow footer</vc-footer>
    <p>&nbsp;</p>
    <vc-footer height="96px">custom height</vc-footer>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'FooterPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/footer.vue